<template>
<div v-if="this.showAgeChecker" class="agechecker-confirm pb-5">  
    <div class="text-white pt-2">
        <p class="agechecker-header">I am 18+</p>
        <p class="agechecker-body">You must be 18 or older to play this demo</p>
        <div><button class="button-blue mx-auto w-50" v-on:click="openPopup()">Confirm</button></div>
        <div><button class="btn btn-outline-light w-50 mt-2" onclick="$('.agechecker-container').hide()">Decline</button></div>    
    </div>         
</div>

<div v-else-if="!this.showAgeChecker">
    <div class="cursor-pointer" onclick="toggleGameDemo('open')" data-toggle="modal" data-target="#slotModal">
        <div class="demo-btn">
            <svg class="icon arrow" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="caret-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path fill="currentColor" d="M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"></path></svg>
        </div>
        <div class="demo-text underlined">
            {{ demoplay }}
        </div>
        <div class="demo-text not-underlined">
            {{ demotext }}
        </div>
     
    </div>
</div> 
</template>
<script>
export default {
    name: 'age-checker-gb',  
    props: ['url', 'merchantkey', 'demotext', 'demoplay'],  
    data()
    {
        return {
            showAgeChecker: true,
        }
    },
    mounted()
    {
        this.loadAgecheckedScript();
    },
    methods:
    {
        loadAgecheckedScript: function()
        {
            let script = document.createElement('script')
            script.setAttribute('src', this.url+'/api/jsapi/getjavascript?merchantkey='+this.merchantkey+'&version=1.0')
            script.async = true      
            document.head.appendChild(script)
        },        
        handlereturn: function(event)
        {

            Agechecked.API.modalclose(); 
            var msg = JSON.parse(event.data); 
            
            //  Successful age verification
            if (msg.status == 6 || msg.status == 7 || msg.status == 12)
            {
                //var agecheckid = msg.agecheckid; 
                //var ageverifiedid = msg.ageverifiedid;

                this.showAgeChecker = false
                this.openModalGame();

            }
            // Failed age verification
            else
            {
                this.showAgeChecker = true
            }
        },
        openModalGame: function()
        {
            toggleGameDemo('open')
            $("#age-checker-gb").removeClass("agechecker-container");
            $('#slotModal').modal('show');

        },
        closeModalGamex: function()
        {
            $('#slotModal').modal('hide');
        },        
        openPopup: function()
        {   
            Agechecked.API.registerreturn(event => 
            {
                this.handlereturn(event);
            }); 
            Agechecked.API.createagecheckjson(
            { 
                mode: "javascript", 
                avtype: "agechecked" 
            }).done(function (json)
            {
                Agechecked.API.modalopen(json.agecheckurl); 
            }); 
        }        
    }
};
</script>